import React from "react";
import { Typography } from "@mui/material";

/**
 * Balão de mensagem da conversa simulada.
 * Mensagens do "paciente" (quem testa) ficam à direita; respostas da IA à esquerda.
 * Respostas da IA podem trazer observações internas (o que a atendente
 * precisaria conferir antes de enviar), mostradas abaixo do balão.
 */
function SimulatorMessage({ message }) {
  const isPatient = message.role === "patient";
  const lines = message.content.split("\n");
  const notes = Array.isArray(message.notes) ? message.notes : [];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isPatient ? "flex-end" : "flex-start",
        gap: "4px",
      }}
    >
      <div
        style={{
          padding: "10px",
          borderRadius: "8px",
          backgroundColor: isPatient ? "var(--color-blue-light4, #E8EDFF)" : "var(--color-secondary-light, #FFDFEC)",
          maxWidth: "70%",
          wordWrap: "break-word",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {lines.map((line, i) => (
            <Typography key={i} variant="body2">{line}</Typography>
          ))}
        </div>
        <Typography variant="caption" color="textSecondary">
          {isPatient ? "Paciente" : "IA"} · {new Date(message.date).toLocaleTimeString()}
        </Typography>
      </div>

      {notes.length > 0 && (
        <div
          style={{
            maxWidth: "70%",
            padding: "6px 10px",
            borderRadius: "8px",
            border: "1px dashed var(--color-blue-light3, #BDC9FE)",
            backgroundColor: "var(--color-bg-light, #FFFFFF)",
          }}
        >
          <Typography variant="caption" style={{ fontWeight: 600, color: "var(--color-text-medium, #4A5568)" }}>
            Observações para a equipe (não vão para o paciente)
          </Typography>
          <ul style={{ margin: "2px 0 0", paddingLeft: "18px" }}>
            {notes.map((note, i) => (
              <li key={i}>
                <Typography variant="caption" color="textSecondary">{note}</Typography>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default SimulatorMessage;
